import { render, staticRenderFns } from "./poissaolo-view.vue?vue&type=template&id=48e5f014&scoped=true&"
import script from "./poissaolo-view.vue?vue&type=script&lang=ts&"
export * from "./poissaolo-view.vue?vue&type=script&lang=ts&"
import style0 from "./poissaolo-view.vue?vue&type=style&index=0&id=48e5f014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5f014",
  null
  
)

export default component.exports